import React from 'react';
import './SidenavLayout.css';

export default ({ sidenav, subnav, ...props }) => ( // eslint-disable-line
  <div className="sidenav-layout">
    <nav>{sidenav}</nav>
    <nav className="sidenav-layout-sub">{subnav}</nav>
    <main className="sidenav-layout-main" {...props} />
  </div>
);
